<template>
  <div id="activity">
    <Header :title="title">
      <template slot="right">
        <div class="mybarRight" v-on:click="toSearch">
          <span class="iconfont icon-sousuo f12 color_999" />
        </div>
      </template>
    </Header>

    <main class="MainCon BuyBg1111" id="MainCon">
      <div class="redbag1111Shadow" v-show="redbag.status"></div>
      <div class="redbag1111" v-show="redbag.status">
        <p class="tc"><a :href="redbag.url" target="_blank"><img src="@/assets/images/1111redbag.png" /></a></p>
        <p class="tc mt20" id="redbag1111Cancel" v-on:click="closeRedbag">
          <span class="iconfont icon-close-b f36 color_fff"></span>
        </p>
      </div>

      <p class="myimg"><img src="@/assets/images/elevenBuyBannerBg2021.jpg" /></p>

      <p class="tc"><span class="buyTitleBg1111">行业会场</span></p>
      <div class="ml7 mr7 mt10">
        <div class="indexMenuBoxList flexBetween">
          <div class="flexBox-cell-48 myimg mb5 imgBorder" v-on:click="toUrl(item.url)"
               v-for="(item,index) in activityTradeList" :key="index"><img v-bind:src="item.image_url" /></div>
        </div>
      </div>
      <p class="tc mt10">
        <span class="buyTitleBg1111">抢大额券</span>
      </p>

      <div class="ml7 mr7 mt10">
        <div class="indexMenuBoxList flexBetween">
          <div class="flexBox-cell-48 mb5" v-on:click="toUrl(item.mobile_url)" v-for="(item,index) in couponList"
               :key="index">
            <div class="couponListBrand">
              <div class="myimg"><img v-bind:src="item.bg_image" /></div>
              <div class="couponListBrandBox">
                <p class="tc"><img v-bind:src="item.logo" /></p>
                <p class="color_fff tc f8 mt3">{{ item.shop_name }}</p>
              </div>
            </div>
            <div class="couponListBlock pb5">
              <div class="ml7 mr7">
                <p class="f8 color_999 lh24"><em class="color_eleven">￥<em
                    class="f10">{{ item.coupon_amount }}</em></em>&nbsp;{{ item.describe }}</p>
                <div class="couponListBlockBtn">立即领券&nbsp;<em class="iconfont icon-kuaizhuang"></em></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="ml7 mr7 mt10" v-for="(item, index) in activityList" :key="index">
        <p class="tc">
          <span class="buyTitleBg1111">{{ item.category_name }}</span>
        </p>
        <div class="myimg mt10" v-on:click="toActivity(item.venue_branch_id)">
          <img v-bind:src="item.venue_wap_ad" />
        </div>

        <div class="goodInfoBoxList flexBetween mt10">
          <div class="indexGoodBlock mb5 flexBox-cell-48 rel" v-for="(goods,index2) in item.goodsList"
               :key="index2">

            <template v-if="app.template.type === '92fanli'">
              <NTfanliGoodsListItem :style-name="app.template.style" :goods-data="goods" />
            </template>
            <template v-else-if="app.template.type === 'damai'">
              <DamaiGoodsListItem :style-name="app.template.style" :goods-data="goods" />
            </template>
            <template v-else>
              <IfanliGoodsListItem :style-name="app.template.style" :goods-data="goods" />
            </template>
          </div>
        </div>

      </div>
    </main>

    <footer class="myFooter">
      <div class="indexMenuBox">
        <div class="tc mt8 footerMenu_buy color_38">
          <p class="footerMenuImg618"><img src="@/assets/images/1111icon_red.png" /></p>
          <p class="f10 lh20">主会场</p>
        </div>
        <div class="tc mt8 footerMenu_buy" v-on:click="toBrand">
          <p class="lh16"><em class="iconfont icon-pinpai f16"></em></p>
          <p class="f10 lh18">品牌店铺</p>
        </div>
        <div class="tc mt8 footerMenu_buy" v-on:click="toAll">
          <p class="lh16"><em class="iconfont icon-quanbu f14"></em></p>
          <p class="f10 lh18">全部会场</p>
        </div>
      </div>
    </footer>

    <div class="goTopBtn"><img v-if="btnFlag" src="@/assets/images/backTop.png" v-on:click="toTop"></div>
  </div>
</template>

<script>
import NTfanliGoodsListItem from './92fanli/TopGoodsListItem';
import DamaiGoodsListItem from './damai/TopGoodsListItem';
import IfanliGoodsListItem from './ifanli/TopGoodsListItem';
import Header from '@/components/Header';
import {isMobile} from '@/libs/utils';
import {appService} from '@/services/app';
import {mapState} from 'vuex';

export default {
  components: {
    NTfanliGoodsListItem,
    DamaiGoodsListItem,
    IfanliGoodsListItem,
    Header
  },
  data() {
    return {
      title: '双11全球狂欢季',
      goodsData: {
        status: false,
        isMore: true,
        loading: false,
        list: [],
        pageNum: 1
      },
      activityTradeList: [],
      activityList: [],
      couponList: [],
      btnFlag: false,
      redbag: {
        url: '',
        status: false,
      }
    }
  },
  computed: {
    ...mapState(['app'])
  },
  created() {
    if (!isMobile()) {
      window.location.href = window.location.origin + '/activity';
    }
    this.fetchActivityTradeList();
    this.fetchActivityList();
    this.fetchLargeCouponList();

    if (window.RedbagUrl) {
      this.redbag.url = window.RedbagUrl;
      this.redbag.status = true;
    }
  },
  updated() {
    document.getElementById('MainCon').addEventListener('scroll', this.scrollToTop)
  },
  methods: {
    fetchActivityTradeList: function () {
      let self = this;
      appService.fetchActivityTradeList().then((res) => {
        let {code, data} = res;
        if (code === 1) {
          self.activityTradeList = data;
        }
      });
    },
    fetchActivityList: function () {
      let self = this;
      appService.fetchActivityList().then((res) => {
        let {code, data} = res;
        if (code === 1) {
          self.activityList = data;
        }
      });
    },
    fetchLargeCouponList: function () {
      let self = this;
      appService.fetchLargeCouponList({pageSize: 4}).then((res) => {
        let {code, data: {list}} = res;
        if (code === 1) {
          self.couponList = list;
        }
      });
    },
    toUrl: function (url) {
      if (url) window.location.href = url;
    },
    toSearch: function () {
      this.$router.push({name: 'search'});
    },
    toActivity: function (id) {
      const route = {
        name: 'activity-detail',
        query: {
          id
        }
      };
      this.$router.push(route);
    },
    toBrand: function () {
      this.$router.push({name: 'activity-brand'});
    },
    toAll: function () {
      this.$router.push({name: 'activity-all'});
    },
    scrollToTop: function () {
      this.btnFlag = document.getElementById('MainCon').scrollTop > 180;
    },
    toTop: function () {
      document.getElementById('MainCon').scrollTop = 0;
    },
    closeRedbag: function () {
      this.redbag.status = false;
    }
  }
}
</script>

<style scoped>

</style>
